import React from "react";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { yyyymmddGenerator } from "../Analytics/AnalyticsUtils/yyyymmddGenerator";
import { isCurrentDate } from "./EndDateDropDownAlerts";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useAppStore } from "../../../appStore";
import { enUS, enGB } from "date-fns/locale";
import { alertsFilterDateControlSx } from "./AlertsUtils/alertsFilterBar";

export const StartDateDropDownAlerts = ({
  userFilters,
  setUserFilters,
  siteOptions,
  setTimeFiltersDisabled,
  warningIssued,
  setWarningIssued,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  siteOptions: any;
  setTimeFiltersDisabled: Dispatcher<boolean>;
  warningIssued: boolean;
  setWarningIssued: Dispatcher<boolean>;
}) => {
  const parentAccounts = JSON.parse(
    localStorage?.getItem?.("parentAccounts") ?? "[]"
  );

  const siteIds = new Map();
  siteOptions.forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  const parentIds = new Map();
  parentAccounts.forEach((object: any) => {
    parentIds.set(object.name, object.id);
  });

  const [startTimeAnchorEl, setStartTimeAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const startTimeOpen = Boolean(startTimeAnchorEl);
  const handleStartTimeClick = (event: React.MouseEvent<HTMLElement>) => {
    // event.stopPropagation(); // Stop event propagation to prevent table sorting
    setStartTimeAnchorEl(event.currentTarget);
  };
  const handleStartTimeClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation(); // Stop event propagation to prevent table sorting
    setStartTimeAnchorEl(null);
  };

  const { dateMMDDYYYY, setDateMMDDYYYY } = useAppStore();

  const selectedLocale = dateMMDDYYYY ? enUS : enGB;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={selectedLocale}
    >
      <div className="w-full">
      <DatePicker
        label={
          userFilters.start_date ? (
            <div className="flex">
              <>{`Site Date`}</>
              <div>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={startTimeOpen ? "long-menu" : undefined}
                  aria-expanded={startTimeOpen ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleStartTimeClick}
                  sx={{
                    marginLeft: "5px",
                    padding: 0,
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  anchorEl={startTimeAnchorEl}
                  open={startTimeOpen}
                  onClose={handleStartTimeClose}
                  slotProps={{
                    paper: {
                      style: {
                        maxHeight: 48 * 4.5,
                        width: "20ch",
                      },
                    },
                  }}
                >
                  <MenuItem
                    key="mm-dd-yyyy-start"
                    onClick={(event) => {
                      setDateMMDDYYYY(true);
                      handleStartTimeClose(event);
                    }}
                  >
                    MM/DD/YYYY
                  </MenuItem>
                  <MenuItem
                    key="dd-mm-yyyy-start"
                    onClick={(event) => {
                      setDateMMDDYYYY(false);
                      handleStartTimeClose(event);
                    }}
                  >
                    DD/MM/YYYY
                  </MenuItem>
                </Menu>
              </div>
            </div>
          ) : (
            <>Start Date</>
          )
        }
        value={userFilters.start_date}
        onChange={(newValue) => {
          if (!warningIssued && !isCurrentDate(newValue)) {
            alert(
              `Selecting any dates for start date or end date which are not the current date will prevent new alerts from being refreshed in the background`
            );
            setWarningIssued(true);
          }
          if (newValue !== null) {
            if (userFilters.end_date && newValue > userFilters.end_date) {
              alert("Start date cannot be after end date");
              return;
            }
            setUserFilters((previousState: any) => ({
              ...previousState,
              start_date: newValue,
            }));
          }
          if (newValue === null) {
            setTimeFiltersDisabled(true);
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                start_date: null,
                start_time: null,
                end_time: null,
              };
            });
          }
          if (
            yyyymmddGenerator(newValue) !==
            yyyymmddGenerator(userFilters.end_date)
          ) {
            setTimeFiltersDisabled(true);
            setUserFilters((previousState: any) => {
              return { ...previousState, start_time: null, end_time: null };
            });
          }
          if (
            yyyymmddGenerator(newValue) ===
            yyyymmddGenerator(userFilters.end_date)
          ) {
            setTimeFiltersDisabled(false);
          }
        }}
        renderInput={(params) => (
          <TextField
            size="small"
            {...params}
            inputProps={{ ...params.inputProps, autoComplete: "off" }}
            sx={alertsFilterDateControlSx}
          />
        )}
      />
      </div>
    </LocalizationProvider>
  );
};
